export default __webpack_public_path__ + "static/380-d342fc1daf3c1327e722fd8e28863a7e.gif";